import { render } from "./ProgramName.vue?vue&type=template&id=39c51c3b&ts=true"
import script from "./ProgramName.vue?vue&type=script&lang=ts"
export * from "./ProgramName.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__